<template>
  <div class="game-provider-page">
    <div class="game-provider-inner">
      <header class="game-provider-header">
        <div class="game-provider-header__top">
          <div class="game-provider-header__titles">
            <p class="game-provider-eyebrow">
              {{
                isArcade
                  ? ($store.state.language === 'en' ? 'Arcade games' : 'အာကိတ် ဂိမ်းများ')
                  : ($store.state.language === 'en' ? 'Slot games' : 'စလော့ ဂိမ်းများ')
              }}
            </p>
            <h1 class="game-provider-title">
              <span class="game-provider-badge">{{ providerLabel }}</span>
            </h1>
          </div>
          <label class="game-provider-search-wrap">
            <i class="fas fa-search game-provider-search-icon" aria-hidden="true" />
            <input
              v-model="name"
              type="search"
              class="game-search-input"
              autocomplete="off"
              :placeholder="
                $store.state.language === 'en'
                  ? 'Search by game name'
                  : 'ဂိမ်းအမည်ဖြင့် ရှာပါ'
              "
            >
          </label>
        </div>
        <p
          v-if="games.length"
          class="game-provider-count"
        >
          {{
            $store.state.language === 'en'
              ? `${displayGames.length} game${displayGames.length === 1 ? '' : 's'}`
              : `ဂိမ်း ${displayGames.length} ခု`
          }}
        </p>
      </header>

      <div
        v-if="!games.length"
        class="game-provider-empty"
      >
        <i class="fas fa-dice game-provider-empty__icon" aria-hidden="true" />
        <p>{{ $store.state.language === 'en' ? 'Loading games…' : 'ဂိမ်းများ ဖတ်နေပါသည်…' }}</p>
      </div>
      <div
        v-else-if="!displayGames.length"
        class="game-provider-empty"
      >
        <i class="fas fa-search game-provider-empty__icon" aria-hidden="true" />
        <p>
          {{
            $store.state.language === 'en'
              ? 'No games match your search.'
              : 'ရှာဖွေမှုနှင့် ကိုက်ညီသော ဂိမ်း မရှိပါ။'
          }}
        </p>
      </div>
      <div
        v-else
        class="game-grid"
      >
        <button
          v-for="(game, index) in displayGames"
          :key="index"
          type="button"
          class="game-tile"
          @click="gameInit(game)"
        >
          <span class="game-tile__thumb">
            <img
              :src="imageLinkGenerate(game.gameID, game.provider)"
              :alt="game.gameName || ''"
              loading="lazy"
              @error="onGameThumbnailError"
            >
          </span>
          <span
            class="game-tile__name"
            :title="game.gameName || ''"
          >{{ game.gameName || '—' }}</span>
        </button>
      </div>
    </div>

    <van-overlay :show="isLoading">
      <div
        class="wrapper"
        @click.stop
      >
        <van-loading
          type="spinner"
          color="#ffffff"
          class="mx-auto"
        />
      </div>
    </van-overlay>
  </div>
</template>
<script>
import { Dialog } from 'vant';
import { mapActions } from 'vuex';

export default {
  //   components: { DropdownMenu, DropdownItem },

  data() {
    return {
      isLoading: false,
      games: [],
      rows: 0,
      provider: 'Pragmatic',
      name: '',
      option1: [
        // { text: 'All', value: 'all' },
        { text: 'Pragmatic Play', value: 'Pragmatic' },
        { text: 'Jili', value: 'Jili' },
        { text: 'Play Star', value: 'Playstar' },
        { text: 'Fast Spin', value: 'Fastspin' },
        { text: 'Spade Gaming', value: 'Spade' },
      ],
    };
  },
  computed: {
    providerLabel() {
      return this.$route.query.provider || '—';
    },
    isArcade() {
      return this.$route.path.includes('/arcade');
    },
    displayGames() {
      const list = this.games.filter((g) => g.provider !== 'Blueprint');
      const q = (this.name || '').trim().toLowerCase();
      if (!q) return list;
      return list.filter((g) => (g.gameName || '').toLowerCase().includes(q));
    },
  },
  methods: {
    onGameThumbnailError(event) {
      const img = event.target;
      if (img.dataset.fallbackApplied) return;
      img.dataset.fallbackApplied = '1';
      img.src = 'https://storage.googleapis.com/spacetech2/mdl/logo.png';
      img.classList.add('game-tile__img--fallback');
    },
    ...mapActions(['fetchUser']),
    imageLinkGenerate(gameId, type) {
      if (type === 'Jili') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/jili/${gameId}.webp`;
      } if (type === 'Rich88') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/rich88/${gameId}.webp`;
      } if (type === 'Live22') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/live22/${gameId}.webp`;
      } if (type === 'Spade') {
        return `https://merchantapi.silverkirin88.com/thumbnail/en_US/${gameId}.jpg`;
      } if (type === 'Fastspin') {
        return `http://api-egame-staging.fsuat.com/thumbnail/en_US/${gameId}.jpg`;
      } if (type === 'Playstar') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/playstar/${gameId}.webp`;
      } if (type === 'FaChai') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/fachai/${gameId}.webp`;
      } if (type === 'PGSoft') {
        return `https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/pgsoft/pgsoft_${gameId}.webp`;
      } if (type === 'JOKER' || type === 'Joker') {
        return `https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/joker/${gameId}.webp`;
      } if (type === '5G') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/5g/${gameId}.webp`;
      } if (type === 'KA') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/newKA/${gameId}.webp`;
      } if (type === 'AceWin') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/acewin/${gameId}_EN.webp`;
      } if (type === 'JDB') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/jdb/${gameId}.webp`;
      } if (type === 'Buffalo' || type === 'AfricanBuffalo') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/afb/${gameId}.webp`;
      } if (type === 'HotDog') {
        return `https://res.hotdog-gaming.com/banners/380x500/${gameId}.png`;
      } if (type === 'Rich') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/rich/${gameId}.webp`;
      } if (type === 'CQ9' || type === 'cq9' || type === 'SexySlot') {
        return `https://space-tech.sgp1.cdn.digitaloceanspaces.com/slot-images/cq9/cq9_${gameId}.webp`;
      } if (type === 'BTG') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/btg/${gameId}.webp`;
      } if (type === 'BNG') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/bng/${gameId}.webp`;
      } if (type === '2J') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/2j/${gameId}.webp`;
      } if (type === 'VA') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/va/${gameId}_en.webp`;
      } if (type === 'AFGame') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/AFG-Square/${gameId}.webp`;
      }
      return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/pp/${gameId}.webp`;
    },
    detectMob() {
      let check = false;
      /* eslint-disable */
      (function (a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            a,
          )
          || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            a.substr(0, 4),
          )
        ) { check = true; }
      }(navigator.userAgent || navigator.vendor || window.opera));
      return check;
    },
    async fetchGames() {
      try {
        const isArcade = this.isArcade;
        const res = await axios.get('/games', {
          params: {
            provider: this.$route.query.provider,
            ...(isArcade ? { type: 'ac' } : {}),
          },
        });

        this.games = res.data.data || [];

        if (!isArcade) {
          this.games = this.games.filter((game) => game.gameTypeID && game.gameTypeID.includes('vs'));
        }
      } catch (error) {
        console.log(error);
      }
    },

    async gameInit(game, isTest = false) {
      try {
        this.isLoading = true;
        this.$store.commit('setLoading', true);
        const authUser = await this.fetchUser();
        if (!authUser) {
          this.$router.push('/auth/login');
          this.isLoading = false;
          this.$store.commit('setLoading', false);
          return;
        }
        if (authUser && !authUser.is_verified) {
          this.$router.push('/auth/verify');
          this.isLoading = false;
          this.$store.commit('setLoading', false);
          return;
        }

        const playType = isTest ? 'demo' : 'real';
        const res = await axios.get('/games/url', {
          params: {
            gameID: game.gameID,
            provider: game.provider || this.$route.query.provider,
            type: playType,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });

        const data = res?.data?.data ?? res?.data ?? {};
        const apiDescription =
          data?.description ??
          res?.data?.description ??
          data?.message ??
          res?.data?.message ??
          '';
        let gameUrl =
          data.gameUrl ??
          data.game_url ??
          data.url ??
          res?.data?.gameUrl ??
          res?.data?.url ??
          '';
        gameUrl = String(gameUrl || '').trim();

        let rawHtml =
          data.html ??
          res?.data?.html ??
          (typeof res?.data === 'string' && res.data.trimStart().startsWith('<')
            ? res.data
            : null) ??
          (gameUrl && gameUrl.trimStart().startsWith('<') ? gameUrl : null);
        if (!rawHtml) rawHtml = '';
        if (rawHtml && typeof rawHtml === 'string') {
          const blob = new Blob([rawHtml], { type: 'text/html;charset=utf-8' });
          gameUrl = URL.createObjectURL(blob);
        }

        if (gameUrl) {
          this.$store.commit('setIframeURL', gameUrl);
          this.$router.push('/iframeURL');
        } else {
          Dialog.alert({
            title: 'အကြောင်းကြားချက်',
            message: String(apiDescription).trim() || 'ဂိမ်းလင့်မရရှိပါ။ Customer service သို့ ဆက်သွယ်ပေးပါ။',
            confirmButtonText: 'OK',
          });
        }

        this.isLoading = false;
        this.$store.commit('setLoading', false);
      } catch (error) {
        this.isLoading = false;
        this.$store.commit('setLoading', false);
        const message =
          error?.response?.data?.message ||
          error?.response?.data?.description ||
          'ဂိမ်းဖွင့်၍ မရပါ။ ထပ်မံကြိုးစားကြည့်ပါ။';
        Dialog.alert({
          title: 'အကြောင်းကြားချက်',
          message,
          confirmButtonText: 'OK',
        });
      }
    },
  },
  watch: {
    provider() {
      this.fetchGames();
    },
    '$route.fullPath'() {
      this.name = '';
      this.fetchGames();
    },
  },
  async mounted() {
    const authUser = await this.fetchUser();
    if (!authUser) {
      this.$router.push('/auth/login');
    }
    this.fetchGames();
    // if (!this.$auth.user().is_verified) {
    //   this.$router.push('/auth/verify');
    // }
  },
};
</script>
<style scoped>
.game-provider-page {
  min-height: 100vh;
  height: auto;
  background-image: url('https://storage.googleapis.com/spacetech2/mdl/bg.png');
  background-size: cover;
  background-position: center top;
  background-attachment: fixed;
  overflow-y: scroll;
  overflow-x: hidden;
}

.game-provider-inner {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0.75rem clamp(0.65rem, 3vw, 1.25rem) 2rem;
}

.game-provider-header {
  padding: 0.5rem 0 1rem;
  margin-bottom: 0.5rem;
}

.game-provider-header__top {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}

@media (min-width: 640px) {
  .game-provider-header__top {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 1.25rem;
  }
}

.game-provider-eyebrow {
  margin: 0 0 0.2rem;
  font-size: 0.72rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: rgba(207, 214, 241, 0.55);
}

.game-provider-title {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 600;
  line-height: 1.3;
}

.game-provider-badge {
  display: inline-block;
  padding: 0.28rem 0.75rem;
  background: rgba(155, 196, 255, 0.14);
  color: #9bc4ff;
  border-radius: 999px;
  border: 1px solid rgba(155, 196, 255, 0.22);
  font-size: 0.95rem;
}

.game-provider-search-wrap {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex: 1;
  min-width: 0;
  max-width: 100%;
  margin: 0;
  background: rgba(19, 23, 48, 0.72);
  border: 1px solid #323743;
  border-radius: 10px;
  padding: 0.45rem 0.85rem;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

@media (min-width: 640px) {
  .game-provider-search-wrap {
    flex: 0 1 320px;
    max-width: 320px;
  }
}

.game-provider-search-wrap:focus-within {
  border-color: #9bc4ff;
  box-shadow: 0 0 0 2px rgba(155, 196, 255, 0.18);
}

.game-provider-search-icon {
  color: rgba(207, 214, 241, 0.45);
  font-size: 0.85rem;
  flex-shrink: 0;
}

.game-search-input {
  flex: 1;
  min-width: 0;
  border: none;
  background: transparent;
  color: #cfd6f1;
  font-size: 0.95rem;
  line-height: 1.4;
}

.game-search-input::placeholder {
  color: rgba(207, 214, 241, 0.45);
}

.game-search-input:focus {
  outline: none;
}

.game-provider-count {
  margin: 0.65rem 0 0;
  font-size: 0.8rem;
  color: rgba(207, 214, 241, 0.5);
}

.game-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
}

@media (min-width: 768px) {
  .game-grid {
    gap: 12px;
  }
}

.game-tile {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 0;
  padding: 0;
  margin: 0;
  background: transparent;
  border-radius: 12px;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
  border: none;
  -webkit-tap-highlight-color: transparent;
  text-align: center;
}

.game-tile__thumb {
  display: block;
  width: 100%;
  overflow: hidden;
  background: transparent;
}

.game-tile:hover {
  transform: translateY(-3px);
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.38);
}

.game-tile:focus-visible {
  outline: 2px solid #9bc4ff;
  outline-offset: 3px;
}

.game-tile:active {
  transform: translateY(-1px);
}

.game-tile img {
  display: block;
  width: 100%;
  aspect-ratio: 3 / 4;
  object-fit: cover;
  vertical-align: middle;
}

.game-tile img.game-tile__img--fallback {
  object-fit: contain;
  padding: 0.65rem;
  box-sizing: border-box;
}

.game-tile__name {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  padding: 0.35rem 0.3rem 0.5rem;
  font-size: 0.62rem;
  line-height: 1.25;
  font-weight: 500;
  color: #cfd6f1;
  word-break: break-word;
  background: transparent;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.9);
  min-height: 2.35em;
}

@media (min-width: 400px) {
  .game-tile__name {
    font-size: 0.68rem;
    padding: 0.4rem 0.35rem 0.55rem;
  }
}

@media (min-width: 768px) {
  .game-tile__name {
    font-size: 0.75rem;
    -webkit-line-clamp: 3;
    min-height: 2.85em;
  }
}

.game-provider-empty {
  text-align: center;
  padding: 3rem 1.25rem;
  color: rgba(207, 214, 241, 0.65);
  font-size: 0.95rem;
}

.game-provider-empty__icon {
  font-size: 2rem;
  margin-bottom: 0.75rem;
  opacity: 0.45;
  display: block;
}

.provider-dropdown {
  width: 200px;
  height: 40px;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
</style>
